<template>
  <v-app>
    <div class="progress-container">
      <progress-linear />
    </div>
    <router-view />
    <v-container>
      <snack-bar />
    </v-container>
  </v-app>
</template>

<script>
import SnackBar from "@/components/shared/SnackBar";
import ProgressLinear from "./components/shared/ProgressLinear";
export default {
  name: "App",
  components: {
    ProgressLinear,
    SnackBar,
  },
  data: () => ({
    inactivityTimer: null,
    inactivityThreshold: 60 * 60 * 1000, // 10 minutes in milliseconds
  }),
  mounted() {
    // Start tracking user activity
    this.resetInactivityTimer();
    window.addEventListener("mousemove", this.resetInactivityTimer);
    window.addEventListener("keydown", this.resetInactivityTimer);
  },
  methods: {
    resetInactivityTimer() {
      // Clear existing timer
      clearTimeout(this.inactivityTimer);
      // Start a new timer
      this.inactivityTimer = setTimeout(
        this.logoutUser,
        this.inactivityThreshold
      );
    },
    logoutUser() {
      // Perform logout logic here (e.g., clear authentication state, redirect to login page)
      // For example:
      // this.$store.commit('logout');
      // this.$router.push('/login');
      this.$store.dispatch("logout");
    },
  },
  beforeDestroy() {
    // Clean up event listeners
    window.removeEventListener("mousemove", this.resetInactivityTimer);
    window.removeEventListener("keydown", this.resetInactivityTimer);
  },
};
</script>

<style>
/* @import "./assets/css/global.css"; */

.progress-container {
  /* height: 3px;  */
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 9999;
}
</style>
